import { create } from "zustand";

interface AuthUIState {
  redirectAfterLogin: string | null;
  setRedirect: (path: string | null) => void;
}

export const useAuthUIStore = create<AuthUIState>((set) => ({
  redirectAfterLogin: null,
  setRedirect: (path) => set({ redirectAfterLogin: path }),
}));
